import { useEffect } from 'react'
import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/downloads/DownloadValueproposition'

const Download: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <CustomHead
        keyword={'バリュープロポジション フレームワーク デザイン デザイン思考'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/download/value-proposition/'}
        title="バリュープロポジションキャンバス | 資料ダウンロード | Aitria（アイトリア）"
        description="バリュープロポジションキャンバスは、「提供する価値」と「顧客像」に焦点を置き、「サービスの価値」と「ユーザーの欲求」のギャップを明確にするフレームワークです。顧客のニーズを再確認し、自社の強みと競争優位性を認識しましょう。"
      />
      <Template />
    </>
  )
}

export default Download
